(function() {
  var AccessController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AccessController = App.loadClass('admin::Angular/AccessController');

  exports.SlackFilesController = (function(superClass) {
    extend(SlackFilesController, superClass);

    function SlackFilesController(scope, transitions, service, q, http) {
      this.scope = scope;
      this.transitions = transitions;
      this.service = service;
      this.q = q;
      this.http = http;
      this.deleteAll = bind(this.deleteAll, this);
      this.deleteFile = bind(this.deleteFile, this);
      this.findUserById = bind(this.findUserById, this);
      this.getFiles = bind(this.getFiles, this);
      SlackFilesController.__super__.constructor.call(this, 'slack_files', this.http);
      this.scope.fullpage = true;
      this.scope.title = 'Manage Your Slack Files';
      this.scope.token = null;
      this.scope.actuallyAll = false;
      this.scope.files = [];
      this.scope.displayedCollection = [];
      this.scope.users = [];
      this.scope.parseInt = parseInt;
      this.scope.findUserById = this.findUserById;
      this.scope.deleteFile = this.deleteFile;
      this.scope.deleteAll = this.deleteAll;
      this.loadScopeData(this.service.getToken(), 'token').then((function(_this) {
        return function() {
          return _this.scope.$watch('token', function(token) {
            if (!token) {
              return;
            }
            return _this.service.saveToken(token).then(function() {
              return _this.getFiles();
            });
          });
        };
      })(this));
      this.getFiles();
    }

    SlackFilesController.prototype.getFiles = function() {
      var promises;
      promises = [];
      promises.push(this.loadScopeData(this.service.getUsers(), 'users'));
      promises.push(this.loadScopeData(this.service.getFiles(), 'files'));
      return this.q.all(promises).then((function(_this) {
        return function() {
          var file, i, len, ref;
          ref = _this.scope.files;
          for (i = 0, len = ref.length; i < len; i++) {
            file = ref[i];
            file.person = _this.findUserById(file.user).profile.real_name;
          }
          return angular.element(_this.window).trigger('resize');
        };
      })(this));
    };

    SlackFilesController.prototype.findUserById = function(id) {
      var i, len, ref, user;
      ref = this.scope.users;
      for (i = 0, len = ref.length; i < len; i++) {
        user = ref[i];
        if (user.id === id) {
          return user;
        }
      }
      return {
        name: 'Unknown'
      };
    };

    SlackFilesController.prototype.deleteFile = function(file) {
      return this.service.deleteFile(file.id).then((function(_this) {
        return function(response) {
          if (response.data.status.type === 'success' && (response.data.data.ok != null)) {
            return _this.scope.files.splice(_this.scope.files.indexOf(file), 1);
          }
        };
      })(this));
    };

    SlackFilesController.prototype.deleteAll = function() {
      var collection, file, i, len, results;
      collection = this.scope.actuallyAll ? this.scope.files : this.scope.displayedCollection;
      results = [];
      for (i = 0, len = collection.length; i < len; i++) {
        file = collection[i];
        results.push(this.deleteFile(file));
      }
      return results;
    };

    return SlackFilesController;

  })(AccessController);

}).call(this);
